/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ReferencedPersonNameDTO
 */
export interface ReferencedPersonNameDTO  {
    /**
     * 
     * @type {number}
     * @memberof ReferencedPersonNameDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReferencedPersonNameDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedPersonNameDTO
     */
    givenname?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedPersonNameDTO
     */
    salutation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedPersonNameDTO
     */
    isMain?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReferencedPersonNameDTO
     */
    personId?: number;
}

/**
 * Check if a given object implements the ReferencedPersonNameDTO interface.
 */
export function instanceOfReferencedPersonNameDTO(value: object): value is ReferencedPersonNameDTO {
    return true;
}

export function ReferencedPersonNameDTOFromJSON(json: any): ReferencedPersonNameDTO {
    return ReferencedPersonNameDTOFromJSONTyped(json, false);
}

export function ReferencedPersonNameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencedPersonNameDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'surname': json['surname'] == null ? undefined : json['surname'],
                  'givenname': json['givenname'] == null ? undefined : json['givenname'],
                  'salutation': json['salutation'] == null ? undefined : json['salutation'],
                  'isMain': json['isMain'] == null ? undefined : json['isMain'],
                  'personId': json['personId'] == null ? undefined : json['personId'],
    };
}

export function ReferencedPersonNameDTOToJSON(json: any): ReferencedPersonNameDTO {
    return ReferencedPersonNameDTOToJSONTyped(json, false);
}

export function ReferencedPersonNameDTOToJSONTyped(value?: ReferencedPersonNameDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'surname': value['surname'],
        'givenname': value['givenname'],
        'salutation': value['salutation'],
        'isMain': value['isMain'],
        'personId': value['personId'],
    };
}


